import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Rectangle, Shadow, Typography, FlexContainer } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const FixturePointStatistics = ({ sport, averagePointsFor, averagePointsAgainst }) => (
  <Shadow>
    <Rectangle fill="white" radius="rounded">
      <Cushion
        vertical="medium"
        horizontal="large"
        responsive={[{ minWidth: 'tab', props: { all: 'xlarge' } }]}
      >
        <Cushion bottom="medium">
          <Typography preset="tab--active" align="center" component="div">
            <Trans i18nKey={`teams:fixture_average_points${sport === 'cricket' ? '_cricket' : ''}`}>
              Average Points:
            </Trans>
          </Typography>
        </Cushion>
        <FlexContainer flexDirection="row" justifyContent="space-around" alignItems="center">
          <div>
            <Cushion bottom="xsmall">
              <Typography component="div" preset="title" color="positive" align="center">
                {averagePointsFor}
              </Typography>
            </Cushion>
            <Typography component="div" preset="tag--large" color="silver" align="center">
              <Trans i18nKey={`teams:fixture_average_points_for_${sport}`}>For</Trans>
            </Typography>
          </div>
          <div>
            <Cushion bottom="xsmall">
              <Typography component="div" preset="title" color="negative" align="center">
                {averagePointsAgainst}
              </Typography>
            </Cushion>
            <Typography component="div" preset="tag--large" color="silver" align="center">
              <Trans i18nKey={`teams:fixture_average_points_against_${sport}`}>Against</Trans>
            </Typography>
          </div>
        </FlexContainer>
      </Cushion>
    </Rectangle>
  </Shadow>
);

FixturePointStatistics.propTypes = {
  sport: PropTypes.string.isRequired,
  averagePointsFor: PropTypes.string.isRequired,
  averagePointsAgainst: PropTypes.string.isRequired,
};

export default FixturePointStatistics;
